import Skeleton from 'antd/es/skeleton';
import { DollarSign } from 'lucide-react';

import { dispatchGAEvent } from 'utils/googleAnalytics';
import { logEventToHotjar } from 'utils/logging';

import { Restricted } from 'containers/Restricted';

import { useOrganisationId } from 'hooks/context/useOrganisationId';
import { useFeatureAccessControl } from 'hooks/useFeatureAccessControl';
import { useRedirectTo } from 'hooks/useRedirectTo';

import { NewButton } from '@atoms/buttons/NewButton';

import { PAYOUT_REQUEST_TITLE_TEST_ID } from './constants';
import { CreatePayoutButton } from './CreatePayoutButton';
import { PayoutFilters } from './PayoutFilters';

export const PayoutsHeader = () => {
  const { isCustomerABTestingEnabled } = useFeatureAccessControl();
  const { navigateWithRedirectTo } = useRedirectTo();
  const organisationId = useOrganisationId<number>();

  const { isManualPayoutEnabled, isLoading } = useFeatureAccessControl();

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <div className="w-full items-center">
      <div className="mb-6 flex w-full flex-row justify-between">
        <div
          className="text-2xl font-medium"
          data-testid={PAYOUT_REQUEST_TITLE_TEST_ID}
        >
          Payouts
        </div>
        {isManualPayoutEnabled && (
          <Restricted requiredPermission="payouts:manage">
            <div className="flex flex-row gap-4">
              {/* this is a v2 manual payout button */}

              {isCustomerABTestingEnabled && (
                <NewButton
                  onClick={() => {
                    logEventToHotjar('new-manual-payout:intent');
                    dispatchGAEvent('create_manual_payout_intent', {
                      version: 'v2'
                    });
                    navigateWithRedirectTo(
                      `/org/${organisationId}/payouts/create`
                    );
                  }}
                >
                  <DollarSign strokeWidth={2} size={16} />
                  <div>
                    <p className="text font-medium">Create payout</p>
                    <div className="absolute -right-2 -top-4 rounded-2xl bg-black px-2 py-1 text-xs text-action-secondary">
                      New
                    </div>
                  </div>
                </NewButton>
              )}
              {/* this is a v1 manual payout button */}
              <CreatePayoutButton />
            </div>
          </Restricted>
        )}
      </div>
      <div className="flex w-full flex-row justify-between">
        <PayoutFilters />
      </div>
    </div>
  );
};
